module.exports = __webpack_public_path__ + "img/gibraltar.b3658b1.webp";